import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { ActionsButtons } from 'components/CustomButtons/ActionsButtons';
import { ModalV2 } from 'components/Modal/ModalV2';
import AccountingAccountRelationForm from './AccountingAccountRelationForm';
import { useRuleValidator } from 'hooks/useRuleValidator';
import { useToggle } from 'hooks/useToggle';
import { PERMISSIONS } from 'router/permissions';
import { deleteAccountingAccountRelation } from 'redux/actions/accountingAccountRelation/accountingAccountRelationActions';
import { ACCOUNTING_ACCOUNT_RELATION_LOADINGS } from 'redux/reducers/accountingAccountRelation/accountingAccountRelationTypes';

const {
  CATALOGS_RELATIONSHIP_ACCOUNTING_ACCOUNTS_EDIT,
  CATALOGS_RELATIONSHIP_ACCOUNTING_ACCOUNTS_DELETE,
} = PERMISSIONS;

const ActionsCell = ({ original }) => {
  const dispatch = useDispatch();
  const isLoadingComp = useSelector(({ search }) => search.isLoadingComp);
  const canEdit = useRuleValidator(CATALOGS_RELATIONSHIP_ACCOUNTING_ACCOUNTS_EDIT);
  const canDelete = useRuleValidator(CATALOGS_RELATIONSHIP_ACCOUNTING_ACCOUNTS_DELETE);
  const [isUpdateFormOpen, setIsUpdateFormOpen] = useToggle();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useToggle();

  const loading = isLoadingComp?.[ACCOUNTING_ACCOUNT_RELATION_LOADINGS.DELETE] || false;

  const handleDelete = () => {
    dispatch(deleteAccountingAccountRelation(original.id, setIsDeleteModalOpen));
  };

  const buttons = [
    {
      Icon: EditIcon,
      color: 0,
      onClick: setIsUpdateFormOpen,
      tooltip: "Modificar relación",
      validation: canEdit,
    },
    {
      Icon: DeleteIcon,
      color: 3,
      onClick: setIsDeleteModalOpen,
      tooltip: "Eliminar relación",
      validation: canDelete,
    }
  ];

  return (
    <>
      <ActionsButtons buttons={buttons} />

      {isUpdateFormOpen && (
        <AccountingAccountRelationForm
          data={original}
          open={isUpdateFormOpen}
          setOpen={setIsUpdateFormOpen}
          titlePrefix="Actualizar"
          update
        />
      )}
      {isDeleteModalOpen && (
        <ModalV2
          title="¿Seguro que desea eliminar esta relación de cuenta contable?"
          confirmText="Eliminar"
          open={isDeleteModalOpen}
          onClose={setIsDeleteModalOpen}
          onSubmit={handleDelete}
          justConfirm
          isLoading={loading}
          confirmColor="warning"
        />
      )}
    </>
  );
};

export default ActionsCell;
